export default __webpack_public_path__ + "static/media/e2bd.e64e6295.svg";